import { render, staticRenderFns } from "./InsuranceResume.vue?vue&type=template&id=4a68995b&scoped=true"
import script from "./InsuranceResume.vue?vue&type=script&lang=js"
export * from "./InsuranceResume.vue?vue&type=script&lang=js"
import style0 from "./InsuranceResume.vue?vue&type=style&index=0&id=4a68995b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a68995b",
  null
  
)

export default component.exports